module.exports = __webpack_public_path__ + "static/media/bg-4-features.c6ba0da0.svg";